<template>
  <div class="aboutUs">
    <topbar :imp="navText"></topbar>
    <img class="ban" src="./img/ban.jpg">
    <!-- <ul class="tab">
      <li :class="{on: introIf}" @click="introIf = true">公司简介</li>
      <li :class="{on: !introIf}" @click="introIf = false">公司新闻</li>
    </ul> -->
    <template v-if="introIf">
      <div class="wrap">
        <div class="conTitle">公司简介</div>
        <div class="conTitle_bor"></div>
        <div class="conText">上海航数智能科技有限公司是中国工业数字化解决方案供应商，为各类工业设备提供工业互联网平台解决方案，平台的特殊优势是积累了上十年先进的健康管理技术，并将其应用于工业设备的智能化运营。</div>
      </div>
      <img class="ban" src="./img/img1.jpg">
      <div class="wrap">
        <div class="conTitle">团队简介</div>
        <div class="conTitle_bor"></div>
        <div class="conText">公司创始团队有近十年的世界前沿的相关经验，主持研发的健康管理系统&物联网技术已用于欧洲多个风厂、多种机床、多种大型柴油发动机及全球95%的大型客机型号。</div>
      </div>
      <div class="client">
        <div class="wrap">
          <div class="conTitle colorfff">公司地址</div>
          <div class="conTitle_bor" style="background:#fff;"></div>
          <div class="conText colorfff">公司总部位于上海零号湾科技园，并在北京、西安、武汉及长沙设有研发团队。</div>
        </div>
      </div>
      <!-- <div class="wrap">
        <div class="conTitle">公司地址</div>
        <div class="conTitle_bor"></div>
        <div class="conText">公司总部位于上海零号湾科技园，并在北京、西安、武汉及长沙设有研发团队。</div>
      </div> -->
    </template>
    <!-- <template v-else>
      <div class="wrap">
        <div class="newCon">
          <div id="newTitle">新闻动态</div>
          <div class="newList">
            <img src="./img/newImg0.jpg">
            <div class="newListCon">
              <h6>工业巨头霍尼韦尔的全球CTO Krishna Mikkilineni博士及科技事业部全球总裁Scott Zhang博士一行来我司考察</h6>
              <span>2018-3-13</span>
              <p>3月13号上午，工业巨头霍尼韦尔（Honeywell)的全球CTO Krishna Mikkilineni博士及科技事业部全球总裁Scott Zhang博士一行来我司上海办公室参观考察。我司领导层向Honeywell团队介绍了我司的发展历程，之后详细阐述了工业互联网的现状并与Krishna Mikkilineni先生交换意见。</p>
            </div>
          </div>
          <div class="newList">
            <img src="./img/newImg1.jpg">
            <div class="newListCon">
              <h6>春节前夕，航数智能完成新一轮数千万人民币的融资</h6>
              <span>2018-2-13</span>
              <p>本次融资是航数智能在开拓多个工业领域之后，公司发展的又一新进展，充分体现了资本市场对航数智能2017年公司成绩的肯定。航数智能2018年将进一步扩大对业内最前沿技术研发的投入，巩固在行业中的领先地位。以中国工业数  字化为使命，助力中国制造2025。</p>
            </div>
          </div>
          <div class="newList">
            <img src="./img/newImg2.jpg">
            <div class="newListCon">
              <h6>我司产品在“第二届中国军民两用技术创新应用大赛”中喜获优胜奖</h6>
              <span>2017-10-05</span>
              <p>本次大赛全面考量参赛项目，关注当前的技术先进性、产业化成熟度，又兼顾市场前景、技术发展路径和提升空间。这个奖项是对我司参赛项目的一种肯定，更是对我司研发能力和发展方向的认可，将激励我们继续致力于中国工业大数据健康管理的研究和探索。</p>
            </div>
          </div>
          <div class="newList">
            <img src="./img/newImg3.jpg">
            <div class="newListCon">
              <h6>我司管理层与某海外上市航空集团CEO及高管商谈合作事宜</h6>
              <span>2017-9-28</span>
              <p>我司管理层与某海外上市航空集团CEO及高管在相互了解各自的优势及发展方向之后，双方就海外市场合作事宜进行了深入探讨，达成了合作方向上的一致。</p>
            </div>
          </div>
          <div class="newList">
            <img src="./img/newImg4.jpg">
            <div class="newListCon">
              <h6>我司王鹂辉博士出席“中国制造2025”创新峰会并发表行业见解</h6>
              <span>2017-6-13</span>
              <p>在宁波举办的“智•造未来”中国制造2025创新峰会上，我司的王鹂辉博士受邀对何为智能制造等问题发表见解。王博士认为，从自身所处行业角度来看智能制造，是把工厂中的生产制造设备以及生产出来的产品高度智能化，帮助产生价值的新飞跃，推动传感器技术，赋予这些设备感官器官，使其可以感受自身以及环境的变化；可以通过人工智能处理这些设备的大脑，判断自身问题或达到最大运营效率。</p>
            </div>
          </div>
        </div>
        <div class="pageWrap">
          <div class="page pageOn">1</div>
        </div>
      </div>
    </template> -->
    <botcon></botcon>
  </div>
</template>

<script>
import Topbar from "@/components/base/Topbar/index";
import Botcon from "@/components/base/Botcon/index";
export default {
  name: "AboutUs",
  components: {
    Topbar,
    Botcon
  },
  data() {
    return {
      introIf: true,
      navText: {
        text: "关于我们"
      }
    };
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        let r = window.innerWidth - document.body.clientWidth;
        this.$store.commit("setScroll", r);
      }, 20);
    });
    this.menu();
  },
  methods: {
    menu() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban {
  display: block;
  width: 100%;
  height: auto;
}
.conTitle {
  height: 180px;
  text-align: center;
  font-size: 50px;
  line-height: 52px;
  padding-top: 89px;
  color: #3e3e3e;
}
.conTitle_bor {
  width: 90px;
  height: 1px;
  margin: 0 auto;
  background: #ccc;
}
.conText {
  padding: 20px 130px 78px;
  color: #5e5e5e;
  font-size: 22px;
  line-height: 40px;
  font-weight: lighter;
  text-align: center;
}
.client {
  width: 100%;
  height: 427px;
  background: url("./img/botBg.jpg") no-repeat center top;
}
.colorfff {
  color: #fff !important;
}

.tab {
  width: 328px;
  height: 100px;
  padding-top: 52px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.tab li {
  width: 139px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  color: #3e3e3e;
}
.tab li.on {
  color: #fffeff;
  background: #206dd2;
  border-radius: 3px;
}
.tab li:hover {
  cursor: pointer;
}

.newCon {
  width: 980px;
  height: auto;
  margin: 0 auto;
}
#newTitle {
  width: 100%;
  height: 143px;
  padding-top: 78px;
  margin-bottom: 30px;
  border-bottom: #d6d5d6 solid 1px;
  font-size: 36px;
  color: #3e3e3e;
  line-height: 64px;
}
.newList {
  width: 100%;
  height: 265px;
  display: flex;
}
.newList img {
  display: block;
  width: 292px;
  height: 217px;
  margin-right: 14px;
}
.newListCon {
  flex: 1;
}
.newListCon h6 {
  font-size: 22px;
  color: #5e5e5e;
  line-height: 34px;
}
.newListCon span {
  display: block;
  font-size: 18px;
  line-height: 28px;
  color: #5e5e5e;
}
.newListCon p {
  padding-top: 20px;
  font-size: 18px;
  line-height: 24px;
  color: #3e3e3e;
}

.pageWrap {
  width: 47px;
  height: 74px;
  margin: 0 auto;
  display: flex;
  align-content: center;
}
.page {
  width: 33px;
  height: 33px;
  margin: 0 7px 0;
  text-align: center;
  font-size: 18px;
  line-height: 33px;
}
.pageOn {
  color: #fff;
  background: #206dd2;
}
.pageNormal {
  color: #5e5e5e;
  border: #9d9d9d solid 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/index.vue